<template>
  <div class="card mx-auto mt-5 card-width shadow">
    <div class="card-body text-secondary">
      <h5 class="card-text font-weight-bold mb-1">
        Drivers love us
      </h5>
      <p class="card-text">
        4.9 Google
        <br>
        <font-awesome-icon
          :icon="['fas', 'star']"
          class="rg-grey"
        />
        <font-awesome-icon
          :icon="['fas', 'star']"
          class="rg-grey"
        />
        <font-awesome-icon
          :icon="['fas', 'star']"
          class="rg-grey"
        />
        <font-awesome-icon
          :icon="['fas', 'star']"
          class="rg-grey"
        />
        <font-awesome-icon
          :icon="['fas', 'star']"
          class="rg-grey"
        />
      </p>

      <h5 class="card-text font-weight-bold mb-1">
        Over 7 billion borrowed
      </h5>
      <p class="card-text">
        20 years of helping customers save
      </p>

      <h5 class="card-text font-weight-bold mb-1">
        We're ready to help
      </h5>
      <p class="card-text">
        <a :href="`tel:${phoneNumber}`">{{ phoneNumber }}</a> or
        <a
          :href="`mailto:${emailAddress}`"
          class="text-decoration-none rg-grey"
        >
          {{ emailAddress }}
        </a>
      </p>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        emailAddress: 'leadChannel/emailAddress',
        phoneNumber: 'leadChannel/phoneNumber'
      })
    }
  };
</script>

<style lang="scss" scoped>
  .card-width {
    width: 320px;
  }
  .card {
    cursor: default;
    border-radius: .6rem;
  }
</style>
